import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestService } from '../../../../services/request.service';

@Component({
  selector: 'app-facility-refuse-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './facility-refuse-modal.component.html',
  styleUrl: './facility-refuse-modal.component.scss',
})
export class FacilityRefuseModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() facilityRefuse = new EventEmitter<{ note: string }>();

  note: string = '';
  type: number | null = null;
  causes: any[] = [];

  constructor(private requestService: RequestService) {}

  cancel(): void {
    this.cancelled.emit();
  }

  confirm() {
    const note =
      this.causes.find((c) => c.id == this.type).name + ' ' + this.note;
    this.facilityRefuse.emit({ note: note });
  }

  ngOnInit() {
    this.requestService.getCauses('RF').subscribe((result) => {
      this.causes = result;
    });
  }
}
